export default "__VITE_ASSET__9RQ_Vj_C__"